import script from "./SimpleSelectField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleSelectField.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleSelectField.vue?vue&type=style&index=0&id=2900e110&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2900e110"]])

export default __exports__